// extracted by mini-css-extract-plugin
export default {"Container":"Footer_Container__AkbfS"};